module.exports = __webpack_public_path__ + "img/brick-wall.18a338e.jpg";